var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistiche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "#1F1F1F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.3777 78.6C85.9777 78.2 85.3777 77.9 84.7777 77.9H82.7777V62.1C82.7777 48.7 82.7777 27.1 82.7777 20.9C82.7777 18.3 82.0777 17.6 79.4777 17.6C75.4777 17.6 71.4777 17.6 67.4777 17.6C64.9777 17.6 64.3777 18.2 64.3777 20.7C64.3777 26.9 64.3777 48.2 64.3777 61.5V78H59.6777V30.1C59.6777 29.9 59.5777 29.7 59.4777 29.6C59.1777 29.1 58.6777 28.8 58.1777 28.8H42.6777C42.1777 28.8 41.6777 29.1 41.3777 29.5C41.1777 29.7 41.1777 29.9 41.1777 30.1V78H37.0777V39C37.0777 36.4 36.4777 35.8 33.8777 35.8C29.8777 35.8 25.8777 35.8 21.8777 35.8C19.3777 35.8 18.6777 36.6 18.6777 39.1V78.2H16.7777C15.5777 78.2 14.5777 79.2 14.5777 80.4C14.5777 81.2 14.9777 82.6 17.9777 82.6H83.5777C85.7777 82.6 86.9777 81.9 86.9777 80.4C86.9777 79.6 86.7777 79.1 86.3777 78.6ZM32.3777 77.9H23.2777V40.4H32.3777V77.9ZM54.9777 77.9H45.8777V33.3H54.9777V77.9ZM77.9777 77.9H68.9777V22.2H77.9777V77.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistiche);
export default __webpack_public_path__ + "static/media/statistiche.0f27178374b149d0ea09feab88a6fd99.svg";
export { ForwardRef as ReactComponent };